import React from 'react';
import { Form, Select } from 'antd';
import styled from 'styled-components';

type TInterviewDateSelectorProps = {
  lastNYearsList: Array<number>;
};

const InterviewDateSelector = ({ lastNYearsList }: TInterviewDateSelectorProps) => {
  return (
    <InterviewDateSelectorWrapper>
      <StyledYearSelector>
        <Form.Item
          className='form-item'
          name={'interview_date_year'}
          label={'인터뷰 일자'}
          rules={[{ required: true }]}
        >
          <Select className='community-selector' placeholder='년도'>
            {/* 최근 n개년도 */}
            {lastNYearsList.map((year) => (
              <Select.Option key={year} value={year}>
                {year}년
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </StyledYearSelector>
      <StyledMonthSelector>
        <Form.Item className='form-item' name={'interview_date_month'} rules={[{ required: true }]}>
          <Select className='community-selector' placeholder='월'>
            {/* 1월 - 12월 */}
            {Array(12)
              .fill(0)
              .map((num, index) => index + 1)
              .map((month) => (
                <Select.Option key={month} value={month}>
                  {month}월
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
      </StyledMonthSelector>
    </InterviewDateSelectorWrapper>
  );
};

export default InterviewDateSelector;

const InterviewDateSelectorWrapper = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-around;
`;
const StyledYearSelector = styled.div`
  width: 49%;
`;

const StyledMonthSelector = styled.div`
  width: 49%;
`;
